import {SEARCH_LOADDATA, SEARCH_CHANGE, PG_REST_URL} from '../Constants'
import {BehaviorSubject, from} from "rxjs";
import {debounceTime, distinctUntilChanged, filter, mergeMap} from "rxjs/operators";
import {isNumeric} from "rxjs/internal-compatibility";

// Load data by Search function
function LoadSearchItemsData(searchStr) {
    // Разбиваем строку поиска на отдельные слова
    const searchTerms = searchStr.trim().split(/\s+/).filter(term => term.length > 0);
    
    // Если нет поисковых терминов, возвращаем пустой результат
    if (searchTerms.length === 0) {
        return Promise.resolve([]);
    }
    
    // Создаем условия для каждого термина
    const conditions = searchTerms.map(term => {
        // Проверяем, является ли термин числовым
        if (isNumeric(term)) {
            return `N_Cat=ilike.*${term}*`;
        } else {
            return `Name=ilike.*${term}*`;
        }
    });
    
    // Объединяем условия через AND для поиска всех слов
    const whereClause = conditions.join('&');
    
    return fetch(PG_REST_URL + '/tab_catalog?price=gt.0&' + whereClause,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => response.json())
}

export let observeSearch = new BehaviorSubject('')
export let observeSearchResult = observeSearch.pipe(
    filter(val => val.length > 3),
    debounceTime(1500),
    distinctUntilChanged(),
    mergeMap(val => from(LoadSearchItemsData(observeSearch.value))),
)

export const searchReducer = (state, action) => {
    switch (action.type) {
        case SEARCH_CHANGE:
            state = action.payload
            observeSearch.next(state)
            return state
        case SEARCH_LOADDATA:
            return state
        default:
            return state
    }
}